import { action, observable } from "mobx";
import { ModelBase } from "@shoothill/core";
import moment from "moment";
import { HireTrackerReportItemDTO } from "./HireTrackerItemModel";
import { HireStatusTypeDTO } from "Globals/Models/Domain/HireStatusTypeModel";

export class IEHireTrackerReportModel extends ModelBase<IEHireTrackerReportModel, any> {
    // #region Constructors and Disposers
    // #endregion Constructors and Disposers

    // #region Constants and Defaults

    // #endregion Constants and Defaults

    // #region Properties

    @observable
    public reportEndDateTop: string | null = null;

    // #endregion Properties

    // #region Actions

    @action
    public reset = () => {
        this.reportEndDateTop = null;
    };

    @action
    public fromDto(dto: any): void {
        //this just iterates through every key assigning it to the model
        //Should only use if there is a direct mapping between dto and domain model
        //otherwise just map them yourself
        for (let key in dto) {
            if (dto.hasOwnProperty(key)) {
                if (this[key] instanceof Date) {
                    this[key] = new Date(dto[key]);
                } else {
                    this[key] = dto[key];
                }
            }
        }
    }

    public toDto(): void {}

    // #endregion Actions

    // #region Custom Validation

    // #endregion Business Logic
}

export type IEHireTrackerReportRequestDTO = {
    projectId: string | null;
    ieId: string | null;
    toDate: string | null;
};

export type IEHireTrackerReportResponseDTO = {
    id: string;
    items: HireTrackerReportItemDTO[];
    hireStatuses: HireStatusTypeDTO[];
};

// export type IEReportItemDTO = {
//     id: string;
//     itemId: string;
//     projectName: string;
//     ieName: string;
//     quantity: number;
//     unitPrice: number;
//     description: string;
//     supplierName: string;
//     categoryName: string;
//     subCategoryName: string;
//     lineDescription: string;
//     formattedPONumber: string;
//     hireStartDate: string; // ISO date string
//     hireEndDate: string; // ISO date string
//     total: number;
//     duration: number;
//     statusName: string;
// };
